import React, { useEffect } from "react";
import { elsewhereLinks, selectedThings } from "./content";

function About() {
  useEffect(() => {
    document.title = "Soham Jog";
  }, []);

  return (
    <main className="mx-auto min-h-screen max-w-3xl px-6 pb-24 pt-16 sm:px-8">
      <div className="space-y-14">
        <header className="space-y-6">
          <div className="space-y-3">
            <h1 className="text-5xl font-bold tracking-tight text-gray-900 sm:text-6xl">
              Soham Jog
            </h1>
          </div>

          <div className="max-w-2xl space-y-5 text-lg leading-8 text-gray-700">
            <p>
              I&apos;m working at Cursor (now SpaceXAI), where I&apos;m learning about Git
              storage and distributed systems.
            </p>
            <p>
              Previously, I studied computer science at Purdue, worked on
              distributed computing research, and built things including Tensara
              and BoilerClasses.
            </p>
          </div>
        </header>

        <section className="space-y-4">
          <h2 className="text-2xl font-medium text-gray-800">
            Selected things
          </h2>
          <div className="flex flex-wrap gap-x-4 gap-y-2 text-base text-gray-700">
            {selectedThings.map((item) => (
              <a
                key={item.label}
                href={item.href}
                target="_blank"
                rel="noopener noreferrer"
                className="site-link"
              >
                {item.label}
              </a>
            ))}
          </div>
        </section>

        <section className="space-y-4">
          <h2 className="text-2xl font-medium text-gray-800">Elsewhere</h2>
          <div className="flex flex-wrap gap-x-4 gap-y-2 text-base text-gray-700">
            {elsewhereLinks.map((item) => (
              <a
                key={item.label}
                href={item.href}
                target="_blank"
                rel="noopener noreferrer"
                className="site-link"
              >
                {item.label}
              </a>
            ))}
          </div>
        </section>
      </div>
    </main>
  );
}

export default About;
